<template>
  <v-row no-gutters style="max-height: 75px">
    <!-- mobile size avatar and menu -->
    <AvatarIconMenu />
    <v-card-subtitle class="d-flex flex-column text-grey pt-0">
      <span class="font-weight-medium text-h6 text-pwt_black font-weight-medium">
        {{ user.fullName }}
      </span>
      <span class="text-pwt_black font-weight-light">
        {{ user.email }}
      </span>
      <span v-if="company?.name" class="text-pwt_black font-weight-light">
        {{ company.name }}
      </span>
    </v-card-subtitle>
    <v-spacer />
  </v-row>
</template>

<script lang="ts" setup>
import type Fleet from '@/classes/fleet';
import User from '@/classes/user_classes/user';
import AvatarIconMenu from './AvatarIconMenu.vue';

const { user, company } = defineProps<{ user: User; company: Fleet | undefined }>()
</script>
